import React from "react";

export default function BrushLibrary({ brushes = [], activeBrushId, onSelect }) {
  return (
    <div>
      <h3 className="font-semibold mb-3">Brush Library</h3>
      <div className="space-y-2">
        {brushes.map((b) => (
          <button
            type="button"
            key={b.id}
            onClick={() => onSelect(b.id)}
            className={`w-full text-left p-2 rounded border ${b.id === activeBrushId ? "bg-indigo-100" : "bg-white"}`}
          >
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm font-medium">{b.name}</div>
                <div className="text-xs text-gray-500">Size: {b.size}px • Opacity: {Math.round(b.opacity * 100)}%</div>
              </div>
              <div style={{ width: 32, height: 24, background: b.color, borderRadius: 4 }} />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

